import { Routes, Route } from "react-router-dom";
import { useAppIcon } from "./lib/appIcon";
import { useAnalytics } from "./lib/analytics";
import { BrandTheme } from "./components/BrandTheme";
import { Layout } from "./routes/Layout";
import { Dashboard } from "./routes/Dashboard";
import { MyTeams } from "./routes/MyTeams";
import { Profile } from "./routes/Profile";
import { RegisterTeam } from "./routes/RegisterTeam";
import { PublicHome } from "./routes/PublicHome";
import { Tournaments } from "./routes/Tournaments";
import { About } from "./routes/About";
import { Host } from "./routes/Host";
import { HostNew } from "./routes/HostNew";
import { TournamentHome } from "./routes/public/TournamentHome";
import { Standings } from "./routes/public/Standings";
import { Schedule } from "./routes/public/Schedule";
import { Bracket } from "./routes/public/Bracket";
import { AdminLayout, RequireGlobalAdmin } from "./routes/admin/AdminLayout";
import { AdminTournaments } from "./routes/admin/AdminTournaments";
import { tournamentRoutes } from "./routes/admin/tournament";
import { AdminVenues } from "./routes/admin/AdminVenues";
import { AdminAdmins } from "./routes/admin/AdminAdmins";
import { AdminUsers } from "./routes/admin/AdminUsers";
import { AdminBranding } from "./routes/admin/AdminBranding";
import { AdminAbout } from "./routes/admin/AdminAbout";
import { AuthLayout } from "./routes/auth/AuthLayout";
import { Login } from "./routes/auth/Login";
import { Signup } from "./routes/auth/Signup";
import { Verify } from "./routes/auth/Verify";
import { ForgotPassword } from "./routes/auth/ForgotPassword";

export function App() {
  // Above the routes, not inside a layout: the auth pages are their own shell,
  // and the tab icon is the organization's on those pages too.
  useAppIcon();
  // Here for the same reason — a pageview hook under Layout would miss every
  // sign-in page.
  useAnalytics();

  return (
    <>
      {/* Same reason as the tab icon: the accent color is the organization's
          on the auth pages too, and those are a sibling shell. */}
      <BrandTheme />
      <Routes>
      {/* Accounts: their own shell, without the app nav. */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      <Route element={<Layout />}>
        <Route path="/" element={<PublicHome />} />
        <Route path="/tournaments" element={<Tournaments />} />
        <Route path="/about" element={<About />} />
        <Route path="/host" element={<Host />} />
        <Route path="/host/new" element={<HostNew />} />

        {/* User front door */}
        <Route path="/me" element={<Dashboard />} />
        <Route path="/me/profile" element={<Profile />} />
        <Route path="/me/teams" element={<MyTeams />} />
        <Route path="/me/register" element={<RegisterTeam />} />

        {/* Public tournament pages */}
        <Route path="/t/:tid" element={<TournamentHome />} />
        <Route path="/t/:tid/d/:did/standings" element={<Standings />} />
        <Route path="/t/:tid/d/:did/schedule" element={<Schedule />} />
        <Route path="/t/:tid/d/:did/bracket" element={<Bracket />} />

        {/* Admin console. The two levels of gate are deliberate: AdminLayout
            admits anyone with console access at all, and the pathless route
            inside it narrows the organization-wide pages to a global admin —
            the same split the API's capability table draws, so a tournament
            role reaches its own event and nothing that belongs to everyone. */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminTournaments />} />
          {tournamentRoutes()}
          <Route element={<RequireGlobalAdmin />}>
            <Route path="venues" element={<AdminVenues />} />
            <Route path="admins" element={<AdminAdmins />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="branding" element={<AdminBranding />} />
            <Route path="about" element={<AdminAbout />} />
          </Route>
        </Route>

        <Route path="*" element={<PublicHome />} />
      </Route>
      </Routes>
    </>
  );
}
